module.exports = __webpack_public_path__ + "assets/img/favicons/apple-icon-76x76.png";